var calcData=require("./calcData.js");
var cData=calcData[cname];
var skillList;
var sortList;
var skillSort={
	"3":[1101,1104,1105,1103,1112,1102,1115,1111,1113,1116,1106,1114],
	"4":[1201,1203,1206,1205,1204,1202,1213,1212,1216,1211,1214,1215],
	"5":[1301,1304,1313,1303,1315,1316,1302,1314,1311,1312,1305,1306],
	"6":[1501,1503,1516,1504,1502,1513,1505,1512,1511,1514,1506,1515],
	"7":[1401,1402,1406,1411,1405,1413,1412,1414,1416,1404,1403,1415],
	"8":[1602,1603,1615,1604,1606,1611,1601,1614,1616,1605,1613,1612],
	"9":[1701,1711,1705,1716,1713,1702,1714,1715,1703,1712,1704,1706],
	"10":[1901,1902,1904,1905,1907,1906,1908,1903,1909,1910,1911,1912],
	"11":[2110,2114,2115,2116,2117,2118,2119,2121,2124,2125,2127,2129]
}
var training={
	trainingList:[],
	cSkillEnhances:[],
	line:{
		49: '凝神',
		59: '破虚',
		69: '忘情',
		79: '出凡'
	},
	renderSkill:function(data){		
		var _this=this;
		skillList=[]
		for(var i=0;i<data.length;i++){
			var name=data[i].name;
			data[i].skillInfo=this.getSkillInfoByName(name);
			if(data[i].skillInfo!=null){
				skillList.push(data[i]);
			}			
		}
		console.log(skillList,'skillList')
		sortList=[];
		for(i=0;i<skillSort[macroSchool].length;i++){
			for(var j=0;j<skillList.length;j++){
				if(skillSort[macroSchool][i]==skillList[j].skillId){
					sortList.push(skillList[j]);
				}
			}
		}
		console.log(sortList)
		var source   = $("#skillItem-template").html();
		var template = Handlebars.compile(source);
		var html    = template({list:sortList});
		$(".skillList").html(html);
		$(".skillBtn").click(function(){
			var index=$(this).index();
			_this.renderTraining(index);
		})
		$(".skillBtn").eq(0).click();
		$(".skillBtn").hover(function(){
			_this.showTips($(this));
		},function(){
			_this.hideTips($(this));
		})
		$(".ticonCnt").delegate(".tico","mouseover",function(){
			var part=$(this).data("part");
			_this.showTrainingTips(part);
		})
		$(".ticonCnt").delegate(".tico","mouseout",function(){
			_this.hideTrainingTips();
		})
	},
	showTrainingTips:function(part){
		part+="";
		var posArray=part.split("");
		var y=parseInt(posArray[0])-1;
		var x=parseInt(posArray[1])-1;
		var trainingInfo=this.trainingList[x][y];
		var cSkillEnhanceInfo=this.getEnhance(part);
		var enhancePoint;
		if(cSkillEnhanceInfo==null){
			$(".m-trainingTips .level").html(0+"/"+trainingInfo.effect.length);
			console.log(trainingInfo.require.books)
			$(".m-trainingTips .name").html(trainingInfo.require.books);
		}else{
			$(".m-trainingTips .level").html(cSkillEnhanceInfo.enhancePoint+"/"+trainingInfo.effect.length);
			$(".m-trainingTips .name").html(cSkillEnhanceInfo.name);
		}
		
		var htmlstr="";
		for(var i=0;i<trainingInfo.effect.length;i++){
			var style="";
			if(cSkillEnhanceInfo!=null&&cSkillEnhanceInfo.enhancePoint-1==i){
				style="active";
			}
			htmlstr+='<p class="'+style+'">\
                <span class="trainingLevel">'+(i+1)+'级修炼：</span>\
                <span class="requireSkillLevel">修炼所需技能等级：'+trainingInfo.effect[i].layer+'</span><br>\
                <span class="addition">'+trainingInfo.effect[i].value+'</span>\
            </p>';
		}
		$(".m-trainingTips .main").html(htmlstr);
		$(".m-trainingTips .require").html("所需境界："+this.line[trainingInfo.require.line]);
		this.setTipsPos($(".m-trainingTips"),$(".tico[data-part="+part+"]"));
		$(".m-trainingTips").show();
	},
	getEnhance:function(part){
		for(var i=0;i<this.cSkillEnhances.length;i++){
			if(this.cSkillEnhances[i].part==part){
				return this.cSkillEnhances[i];
			}
		}	
		return null;
	},
	hideTrainingTips:function(){
		$(".m-trainingTips").hide();
	},
	showTips:function($this){
		var skillName=$this.data("name");
		var skill=this.getSkillInfoByName(skillName);
		if(!skill) return;
		$(".m-skillTips .name").html(skillName);
		$(".m-skillTips .skillIcon").attr("src",skill.skillImage);
		$(".m-skillTips .skillProperty").empty();
		for(var i=0;i<skill.skillProperty.length;i++){
			$(".m-skillTips .skillProperty").append("<span>"+skill.skillProperty[i]+"</span>");
		}
		$(".m-skillTips .main").html(skill.skillDescribe.main);
		var staticStr="";
		for(i=0;i<skill.skillDescribe.static.length;i++){
			staticStr+="· "+skill.skillDescribe.static[i]+"<br>";
		}
		$(".m-skillTips .static").html(staticStr);
		this.setTipsPos($(".m-skillTips"),$this);
		$(".m-skillTips").show();
	},
	setTipsPos:function($tips,$skillIcon){
		var x=$skillIcon.offset().left+$skillIcon.width()+10;
		var y=$skillIcon.offset().top-$tips.outerHeight()-10;
		y=y<0?0:y;
		if(x+$tips.outerWidth()>1105){
			x=$skillIcon.offset().left-$tips.outerWidth()-10;
		}
		$tips.css({left:x,top:y});
	},
	hideTips:function($this){
		$(".m-skillTips").hide();
	},
	renderTraining:function(index){
		var skill=sortList[index];
		if(skill.cSkillEnhances==undefined){
			skill.cSkillEnhances=[];
		}
		//配的数据
		var training=skill.skillInfo.skillDescribe.training;
		var enhanceList=[];
		for(var i=0;i<training.length;i++){
			for(var j=0;j<training[i].length;j++){
				var part=parseInt((j+1)+""+(i+1));
				if(training[i][j].effect!=undefined){
					enhanceList.push({enhancePoint:0,part:part,limit:training[i][j].effect.length})
				}
			}
		}

		for(i=0;i<enhanceList.length;i++){
			var tempEnhance=enhanceList[i];
			for(j=0;j<skill.cSkillEnhances.length;j++){
				if(parseInt(skill.cSkillEnhances[j].part)==parseInt(tempEnhance.part)){
					tempEnhance.enhancePoint=skill.cSkillEnhances[j].enhancePoint;
				}
			}
		}
		//算点
		var trainingCountObj={
			t1:0,
			t2:0,
			t3:0
		}
		for(i=0;i<skill.cSkillEnhances.length;i++){
			var pos=skill.cSkillEnhances[i].part+"";
			var pos2=pos.substr(1,1);
			if(pos2=="1"||pos2=="2"){
				trainingCountObj.t1+=skill.cSkillEnhances[i].enhancePoint;
			}
			if(pos2=="3"){
				trainingCountObj.t2+=skill.cSkillEnhances[i].enhancePoint;
			}
			if(pos2=="4"||pos2=="5"){
				trainingCountObj.t3+=skill.cSkillEnhances[i].enhancePoint;
			}
		}

		var source   = $("#trainingItem-template").html();
		var template = Handlebars.compile(source);
		var html    = template({list:enhanceList});
		$(".ticonCnt").html(html);
		$(".skillIcon").attr("src",skill.skillInfo.skillImage);
		var trainingNameList=skill.skillInfo.skillDescribe.trainingName;
		$(".skillName").html(skill.name);
		$(".trainingName-1").html(trainingNameList[0]+"："+trainingCountObj.t1);
		$(".trainingName-2").html(trainingNameList[1]+"："+trainingCountObj.t2);
		$(".trainingName-3").html(trainingNameList[2]+"："+trainingCountObj.t3);
		var enhances="";
		for(var i=0;i<skill.cSkillEnhances.length;i++){
			if(skill.cSkillEnhances[i].enhancePoint>0){
				enhances+=skill.cSkillEnhances[i].description+"<br>";
			}
		}
		$(".trainMap .p").html(enhances);
		this.cSkillEnhances=skill.cSkillEnhances;
		this.trainingList=skill.skillInfo.skillDescribe.training;
	},
	getSkillInfoByName:function(name){
		for(var i=0;i<cData.length;i++){
			if(cData[i].skillName==name){
				return cData[i];
			}
		}
		return null;
	},
	getSkillXiulianList:function(){
		training.renderSkill(gameSkillInfo);
		// console.log(gameSkillInfo)
		// $.getJSON("/skillmacros/getSkillXiulianList.json?gbId="+gbId,function(msg){
		// 	training.renderSkill(msg.data);
		// })
	}
}
training.getSkillXiulianList();
module.exports=training;


//////////////////
// WEBPACK FOOTER
// ./pages/skillmacros/js/training.js
// module id = 3
// module chunks = 0 1 3 4